import React from "react";
import { BrowserRouter as Router, Routes, Route, useParams  } from "react-router-dom";

import Header from "./Components/Header";
import TopBar from "./Components/TopBar";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop"; // ✅ ADD THIS

import Hero from "./Components/Hero";
import AboutUs from "./Components/AboutUs";
import ContactUs from "./Components/ContactUs";
import FoundationHero from "./Components/FoundationHero";
import ClassroomPage from "./Components/ClassroomPage";
import CoursePage from "./Components/CoursePage";

import Blog from "./Components/Blog";
import Neet from "./Components/neet";
import JeeHero from "./Components/JeeHero";
import Gallery from "./Components/Gallery";
import BlogDetail from "./Components/BlogDetail";
import FloatingButtons from './Components/FloatingButtons';

import Videos from "./Components/Videos";


// Wrapper reads URL params and passes to CoursePage
function CoursePageWrapper() {
  const { city, stream } = useParams();
  return <CoursePage citySlug={city} streamSlug={stream} />;
}


function App() {
  return (
    <Router>
      <TopBar/>
      <FloatingButtons />
      <Header />
      <ScrollToTop /> {/* ✅ SCROLL FIX */}
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/foundation-classes-in-vadodara" element={<FoundationHero />} />
        
        <Route path="/classes" element={<ClassroomPage />} />
         <Route path="/" element={<ClassroomPage />} />
 
        {/* Course sub-pages: /:city/:stream */}
        {/* Examples:
            /agra/jee-main-advanced
            /ahmedabad/neet
            /vadodara/grade-6-10
            /mumbai/jee-main
        */}
        <Route path="/:city/:stream" element={<CoursePageWrapper />} />

        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/neet-coaching-in-vadodara" element={<Neet />} />
        <Route path="/jee-coaching-in-vadodara" element={<JeeHero />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        
        <Route path="/Videos" element={<Videos />} />
      
      </Routes>
      <Footer />
    </Router>
    
  );
}

export default App;
